// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1UcoC{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:start;align-items:flex-start;margin:0 auto;width:100%;-ms-flex-pack:center;justify-content:center}._1UcoC>video{width:49%;margin-bottom:45px}@media only screen and (max-width:850px){._1UcoC>video{width:100%;margin-bottom:45px}}", ""]);
// Exports
exports.locals = {
	"itemWrapper": "_1UcoC"
};
module.exports = exports;
